/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_ErrorInputs */

const en_admin_registration_error = /** @type {(inputs: Admin_Registration_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const de_admin_registration_error = /** @type {(inputs: Admin_Registration_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Admin_Registration_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_error = /** @type {((inputs?: Admin_Registration_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_error(inputs)
	return en_admin_registration_error(inputs)
});